export default __webpack_public_path__ + "static/media/hinted-subset-Roboto-Light.8fc5f5f2.woff";